import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { handleExportConfiguration, handleExportVerbatimConfiguration } from '../utils/ProjectUtils';
import { useProject } from "../context/ProjectContext"; // Import the context
import LabelTypeExportSelectorModal from '../modals/LabelTypeExportSelectorModal';
import "./NavTabs.css";

// Reusable Menu Component
const Menu = ({ label, iconClass, links }) => {
  const location = useLocation();
  const currentPage = location.pathname;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="nav-tab menu-container"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <span className="menu-label">
        <i className={`fa-solid ${iconClass}`}></i> {label}
      </span>
      {isOpen && (
        <div className="sub-menu">
          {links.map(({ to, label, iconClass }) => (
            <Link
              key={to}
              to={to}
              className={`nav-tab ${currentPage === to ? "active" : ""}`}
            >
              <i className={`fa-solid ${iconClass}`}></i> {label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

const NavTabs = () => {
  const location = useLocation();
  const currentPage = location.pathname;

  // Access project data using useProject
  const { verbatims, notes, slides, labels, labelTypes } = useProject();
  const [modalExportToTxt, setModalExportToTxt] = useState(false);
  const [isSaveOpen, setIsSaveOpen] = useState(false);

  // Wrapper for export configuration
  const handleSave = (choice) => {
    if (choice === "all") {
      handleExportConfiguration({ verbatims, notes, slides, labels, labelTypes });
    } else if (choice === "verbatims") {
      // handleExportVerbatimConfiguration({ verbatims });
      setModalExportToTxt(true);
    }
  };

  const handleExportToTxt = (selectedLabelTypes) => {
    handleExportVerbatimConfiguration({ verbatims, selectedLabelTypes });
    setModalExportToTxt(false);
  };

  return (
    <div className="nav-tabs">
      <div className="nav-links">
        <Link
          to="/home"
          className={`nav-tab ${currentPage === "/home" ? "active" : ""}`}
        >
          <i className="fa-solid fa-home"></i> Home
        </Link>
        <Menu
          label="Labeling"
          iconClass="fa-magnifying-glass"
          links={[
            { to: "/setup", label: "Setup", iconClass: "fa-wrench" },
            { to: "/labeling", label: "Labeling", iconClass: "fa-magnifying-glass" },
            { to: "/batch", label: "Batch", iconClass: "fa-table" },
          ]}
        />
        <Link
          to="/review"
          className={`nav-tab ${currentPage === "/review" ? "active" : ""}`}
        >
          <i className="fa-solid fa-book"></i> Review
        </Link>
        {/* Visualization Menu with Sub-Links */}
        <Menu
          label="Visualization"
          iconClass="fa-chart-bar"
          links={[
            { to: "/visualization", label: "Charts", iconClass: "fa-chart-bar" },
            { to: "/pivot", label: "Pivot", iconClass: "fa-table" },
            { to: "/insight", label: "Slides", iconClass:"fa-lightbulb" }
          ]}
        />
      </div>
      <div className="actions-container">
        <div className="save-container">
          <div
            className="nav-tab menu-container"
            onMouseEnter={() => setIsSaveOpen(true)}
            onMouseLeave={() => setIsSaveOpen(false)}
          >
            <span className="menu-label"></span>
              <i className="fa-solid fa-file-export"></i> Save
            {isSaveOpen && (
              <div className="sub-menu">
                <span
                  className="nav-tab"
                  onClick={() => handleSave("all")}
                >
                  <i className="fa-solid fa-file-export"></i> all (.json)
                </span>
                <span
                  className="nav-tab"
                  onClick={() => handleSave("verbatims")}
                >
                  <i className="fa-solid fa-file-export"></i> verbatims (.txt)
                </span>
              </div>
            )}
          </div>
        </div>
        <div className="logo-container">
          <img
            className="logo"
            src="https://dynvibe.com/web/favicon.png"
            alt="Logo"
          />
        </div>
      </div>
      {modalExportToTxt && <LabelTypeExportSelectorModal onClose={() => setModalExportToTxt(false)} onConfirm={(selectedLabelTypes) => handleExportToTxt(selectedLabelTypes)} />}
    </div>
  );
};

export default NavTabs;
